import { ISanPhamPhamVi } from "../../../model/respone/san-pham/ISanPhamPhamVi"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export const eSanPhamPhamViActionTypeDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ISanPhamPhamVi[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | ISanPhamPhamVi,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as ISanPhamPhamVi,
    SAVE_SUCCESS: {} as ISanPhamPhamVi,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
}
export const eSanPhamPhamViActionTypeIds = generateActionTypeIds(eSanPhamPhamViActionTypeDefine, "SAN_PHAM_PHAM_VI")

export type ISanPhamPhamViActions = IGenericActionType<typeof eSanPhamPhamViActionTypeDefine, "SAN_PHAM_PHAM_VI">
